if (!Object.hasOwn) {
  Object.hasOwn = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key); // NOSONAR
  };
}

if (!Array.prototype.toSorted) {
  Array.prototype.toSorted = function (compareFn) { // NOSONAR
    return [...this].sort(compareFn); 
  };
}

if (typeof structuredClone !== "function") {
  globalThis.structuredClone = function (value) {
    return JSON.parse(JSON.stringify(value));
  };
}
